import { useQuery } from "@tanstack/react-query";
import { recurringApi } from "../api/recurring";
import { queryClient } from "../../../shared/providers/QueryProvider";

export const useOperationsList = ({ projectId }: { projectId: string | undefined }) => {

  const { data, isLoading, isError, isSuccess, refetch } = useQuery({
    queryKey: ["recurring-list", projectId],
    queryFn: () => recurringApi.getRecurringList({ projectId }),
    enabled: !!projectId,
  });

  return {
    operations: isSuccess ? data.data : [],
    loading: isLoading,
    error: isError ? "Failed to load operations." : null,
    refetch,
    removeCache: () => { queryClient.removeQueries({ queryKey: ["recurring-list", projectId] }); }
  };

};